// Dashboard icons
import iconClinicalAdmin from '@/assets/menu/icon_dashboard_clinical_admin.svg';
import iconFluSNIFF from '@/assets/menu/icon_dashboard_fluSNIFF.svg';
import iconHci from '@/assets/menu/icon_dashboard_hci.svg';
import iconPatientApproval from '@/assets/menu/icon_dashboard_patient_approval.svg';
import iconPatientAssignment from '@/assets/menu/icon_dashboard_patient_assignment.svg';
import iconPatientContact from '@/assets/menu/icon_dashboard_patient_contact.svg';
import iconPatientEngagement from '@/assets/menu/icon_dashboard_patient_engagement.svg';
import iconPatientList from '@/assets/menu/icon_dashboard_patient_lists.svg';
import iconPatientRegistrations from '@/assets/menu/icon_dashboard_patient_registrations.svg';
import iconPatientScreening from '@/assets/menu/icon_dashboard_patient_screening.svg';
import iconReporting from '@/assets/menu/icon_dashboard_reporting.svg';
import iconTrialSite from '@/assets/menu/icon_dashboard_trial_site.svg';
// Menu active icons
import iconMenuActiveDataCaptureTrialSite from '@/assets/menu/icon_menu_active_brain_health.svg';
import iconMenuAciveClinicalAdmin from '@/assets/menu/icon_menu_active_clinical_admin.svg';
import iconMenuActiveFluSNIFF from '@/assets/menu/icon_menu_active_fluSNIFF.svg';
import iconMenuActiveHci from '@/assets/menu/icon_menu_active_hci.svg';
import iconMenuActiveHome from '@/assets/menu/icon_menu_active_home.svg';
import iconMenuActivePatientApproval from '@/assets/menu/icon_menu_active_patient_approval.svg';
import iconMenuActivePatientAssignment from '@/assets/menu/icon_menu_active_patient_assignment.svg';
import iconMenuActivePatientContact from '@/assets/menu/icon_menu_active_patient_contact.svg';
import iconMenuActivePatientEngagement from '@/assets/menu/icon_menu_active_patient_engagement.svg';
import iconMenuActivePatientLists from '@/assets/menu/icon_menu_active_patient_lists.svg';
import iconMenuActivePatientRegistrations from '@/assets/menu/icon_menu_active_patient_registrations.svg';
import iconMenuActivePatientScreening from '@/assets/menu/icon_menu_active_patient_screening.svg';
import iconMenuActiveReporting from '@/assets/menu/icon_menu_active_reporting.svg';
import iconMenuActiveTrialSite from '@/assets/menu/icon_menu_active_trial_site.svg';
// Menu icons
import iconMenuDataCaptureTrialSite from '@/assets/menu/icon_menu_default_brain_health.svg';
import iconMenuClinicalAdmin from '@/assets/menu/icon_menu_default_clinical_admin.svg';
import iconMenuFluSNIFF from '@/assets/menu/icon_menu_default_fluSNIFF.svg';
import iconMenuHci from '@/assets/menu/icon_menu_default_hci.svg';
import iconMenuHome from '@/assets/menu/icon_menu_default_home.svg';
import iconMenuPatientApproval from '@/assets/menu/icon_menu_default_patient_approval.svg';
import iconMenuPatientAssignment from '@/assets/menu/icon_menu_default_patient_assignment.svg';
import iconMenuPatientContact from '@/assets/menu/icon_menu_default_patient_contact.svg';
import iconMenuPatientEngagement from '@/assets/menu/icon_menu_default_patient_engagement.svg';
import iconMenuPatientLists from '@/assets/menu/icon_menu_default_patient_lists.svg';
import iconMenuPatientRegistrations from '@/assets/menu/icon_menu_default_patient_registrations.svg';
import iconMenuPatientScreening from '@/assets/menu/icon_menu_default_patient_screening.svg';
import iconMenuReporting from '@/assets/menu/icon_menu_default_reporting.svg';
import iconMenuTrialSite from '@/assets/menu/icon_menu_default_trial_site.svg';
// Menu Hover items
import iconMenuHoverDataCaptureTrialSite from '@/assets/menu/icon_menu_hover_brain_health.svg';
import iconMenuHoverClinicalAdmin from '@/assets/menu/icon_menu_hover_clinical_admin.svg';
import iconMenuHoverFluSNIFF from '@/assets/menu/icon_menu_hover_fluSNIFF.svg';
import iconMenuHoverHci from '@/assets/menu/icon_menu_hover_hci.svg';
import iconMenuHoverHome from '@/assets/menu/icon_menu_hover_home.svg';
import iconMenuHoverPatientApproval from '@/assets/menu/icon_menu_hover_patient_approval.svg';
import iconMenuHoverPatientAssignment from '@/assets/menu/icon_menu_hover_patient_assignment.svg';
import iconMenuHoverPatientContact from '@/assets/menu/icon_menu_hover_patient_contact.svg';
import iconMenuHoverPatientEngagement from '@/assets/menu/icon_menu_hover_patient_engagement.svg';
import iconMenuHoverPatientLists from '@/assets/menu/icon_menu_hover_patient_lists.svg';
import iconMenuHoverPatientRegistrations from '@/assets/menu/icon_menu_hover_patient_registrations.svg';
import iconMenuHoverPatientScreening from '@/assets/menu/icon_menu_hover_patient_screening.svg';
import iconMenuHoverReporting from '@/assets/menu/icon_menu_hover_reporting.svg';
import iconMenuHoverTrialSite from '@/assets/menu/icon_menu_hover_trial_site.svg';
// Other imports
import {
	patientAssignmentFeatureFlagEnabled,
	patientRegistrationsFeatureFlagEnabled,
} from '@/globalConsts/featureFlags';

export type MenuConfigItem = {
	title: string;
	label: string[];
	link: string;
	icon: {
		dashboard: string;
		nav: string;
		navActive: string;
		navHover: string;
	};
	testId: string;
};

export type MenuConfigObject = {
	home: MenuConfigItem[];
	care_agent: MenuConfigItem[];
	study_site_admin: MenuConfigItem[];
	flusniff_plus_approver: MenuConfigItem[];
};

export const menuConfig = {
	home: [
		{
			icon: {
				dashboard: iconMenuHome,
				nav: iconMenuHome,
				navActive: iconMenuActiveHome,
				navHover: iconMenuHoverHome,
			},
			link: '/',
			testId: 'home',
			title: 'Home',
			label: ['home'],
		},
	],
	care_agent: [
		{
			title: 'Health Care Institution',
			label: ['health-care-institution'],
			link: '/health-care-institution',
			icon: {
				dashboard: iconHci,
				nav: iconMenuHci,
				navActive: iconMenuActiveHci,
				navHover: iconMenuHoverHci,
			},
			testId: 'health-care-institution',
		},
		{
			title: 'Reporting',
			link: '/reporting',
			icon: {
				dashboard: iconReporting,
				nav: iconMenuReporting,
				navActive: iconMenuActiveReporting,
				navHover: iconMenuHoverReporting,
			},
			label: [
				'study_progress_metrics',
				'patient_status_metrics',
				'survey_follow_up',
				'internal_study_admin',
				'dashboard',
			],
			testId: 'reporting',
		},
		{
			title: 'Patient Engagement',
			label: ['patient_engagement'],
			link: '/patient-engagement',
			icon: {
				dashboard: iconPatientEngagement,
				nav: iconMenuPatientEngagement,
				navActive: iconMenuActivePatientEngagement,
				navHover: iconMenuHoverPatientEngagement,
			},
			testId: 'patient-engagement',
		},
		{
			title: 'Patient Screening',
			label: ['patient_screening'],
			link: '/patient-screening',
			icon: {
				dashboard: iconPatientScreening,
				nav: iconMenuPatientScreening,
				navActive: iconMenuActivePatientScreening,
				navHover: iconMenuHoverPatientScreening,
			},
			testId: 'patient-screening',
		},
		{
			title: 'Patient Contact',
			label: ['patient-contact'],
			link: '/patient-contact',
			icon: {
				dashboard: iconPatientContact,
				nav: iconMenuPatientContact,
				navActive: iconMenuActivePatientContact,
				navHover: iconMenuHoverPatientContact,
			},
			testId: 'patient-contact',
		},
		{
			title: 'Clinical Admin',
			label: ['patient_screening'],
			link: '/clinical-admin',
			icon: {
				dashboard: iconClinicalAdmin,
				nav: iconMenuClinicalAdmin,
				navActive: iconMenuAciveClinicalAdmin,
				navHover: iconMenuHoverClinicalAdmin,
			},
			testId: 'clinical-admin',
		},
		{
			title: 'Patient Lists',
			label: ['patient_lists'],
			link: '/patient-lists',
			icon: {
				dashboard: iconPatientList,
				nav: iconMenuPatientLists,
				navActive: iconMenuActivePatientLists,
				navHover: iconMenuHoverPatientLists,
			},
			testId: 'patient-lists',
		},
		...(patientAssignmentFeatureFlagEnabled
			? [
					{
						title: 'Patient Assignment',
						label: ['patient-assignment'],
						link: '/patient-assignment',
						icon: {
							dashboard: iconPatientAssignment,
							nav: iconMenuPatientAssignment,
							navActive: iconMenuActivePatientAssignment,
							navHover: iconMenuHoverPatientAssignment,
						},
						testId: 'patient-assignment',
					},
				]
			: []),
		...(patientRegistrationsFeatureFlagEnabled
			? [
					{
						title: 'Patient Registrations',
						label: ['patient_registrations'],
						link: '/incomplete-registrations',
						icon: {
							dashboard: iconPatientRegistrations,
							nav: iconMenuPatientRegistrations,
							navActive: iconMenuActivePatientRegistrations,
							navHover: iconMenuHoverPatientRegistrations,
						},
						testId: 'patient-registrations',
					},
				]
			: []),
	],
	study_site_admin: [
		{
			title: 'Trial Sites',
			label: ['trial-sites'],
			link: '/trial-sites',
			icon: {
				dashboard: iconTrialSite,
				nav: iconMenuTrialSite,
				navActive: iconMenuActiveTrialSite,
				navHover: iconMenuHoverTrialSite,
			},
			testId: 'trial-sites',
		},
		{
			title: 'FluSniff Patient Management',
			label: ['trial-site-management'],
			link: '/trial-site-management',
			icon: {
				dashboard: iconFluSNIFF,
				nav: iconMenuFluSNIFF,
				navActive: iconMenuActiveFluSNIFF,
				navHover: iconMenuHoverFluSNIFF,
			},
			testId: 'flu-sniff-trial-site-management',
		},
	],
	flusniff_plus_approver: [
		// Patient approval + FluSniff
		{
			title: 'Patient Approval',
			link: '/patient-approval',
			icon: {
				dashboard: iconPatientApproval,
				nav: iconMenuPatientApproval,
				navActive: iconMenuActivePatientApproval,
				navHover: iconMenuHoverPatientApproval,
			},
			label: ['patients_approval'],
			testId: 'patient-approval',
		},
		{
			title: 'FluSniff Patient Management',
			label: ['trial-site-management'],
			link: '/trial-site-management',
			icon: {
				dashboard: iconFluSNIFF,
				nav: iconMenuFluSNIFF,
				navActive: iconMenuActiveFluSNIFF,
				navHover: iconMenuHoverFluSNIFF,
			},
			testId: 'flu-sniff-trial-site-management',
		},
	],
	patient_approver: [
		{
			title: 'Patient Approval',
			link: '/patient-approval',
			icon: {
				dashboard: iconPatientApproval,
				nav: iconMenuPatientApproval,
				navActive: iconMenuActivePatientApproval,
				navHover: iconMenuHoverPatientApproval,
			},
			label: ['patients_approval'],
			testId: 'patient-approval',
		},
	],
	study_metrics: [
		{
			title: 'Reporting',
			link: '/reporting',
			icon: {
				dashboard: iconReporting,
				nav: iconMenuReporting,
				navActive: iconMenuActiveReporting,
				navHover: iconMenuHoverReporting,
			},
			label: [
				'study_progress_metrics',
				'patient_status_metrics',
				'survey_follow_up',
				'internal_study_admin',
				'dashboard',
			],
			testId: 'reporting',
		},
	],
	trial_sites_user: [
		{
			title: 'Trial Sites',
			label: ['trial-sites'],
			link: '/trial-sites',
			icon: {
				dashboard: iconTrialSite,
				nav: iconMenuTrialSite,
				navActive: iconMenuActiveTrialSite,
				navHover: iconMenuHoverTrialSite,
			},
			testId: 'trial-sites',
		},
	],
	flu_sniff_user: [
		{
			title: 'FluSniff Patient Management',
			label: ['trial-site-management'],
			link: '/trial-site-management',
			icon: {
				dashboard: iconFluSNIFF,
				nav: iconMenuFluSNIFF,
				navActive: iconMenuActiveFluSNIFF,
				navHover: iconMenuHoverFluSNIFF,
			},
			testId: 'flu-sniff-trial-site-management',
		},
	],
	data_capture_trial_site_management: [
		{
			title: 'Data Capture',
			label: ['data-capture'],
			link: '/data-capture',
			icon: {
				dashboard: iconTrialSite,
				nav: iconMenuDataCaptureTrialSite,
				navActive: iconMenuActiveDataCaptureTrialSite,
				navHover: iconMenuHoverDataCaptureTrialSite,
			},
			testId: 'data-capture',
		},
	],
};
